import { v4 as uuidv4 } from "uuid";
 
import Leadership from "../../assets/img/icons/Leadership.svg";
import Collaboration from "../../assets/img/icons/Collaboration.svg";
import Integrityandtrust from "../../assets/img/icons/Integrityandtrust.svg";
import Accountability from "../../assets/img/icons/Accountability.svg";
import Passion from "../../assets/img/icons/Passion.svg";
import Diversity from "../../assets/img/icons/Diversity.svg";

const BrandLogodata = [
  {
    id: uuidv4(),
    brand: Leadership,
    name: "Leadership",
    dec: "The courage to shape a better future.",
  },

  {
    id: uuidv4(),
    brand: Collaboration,
    name: "Collaboration",
    dec: "Leverage collective genius",
  },

  {
    id: uuidv4(),
    brand: Integrityandtrust,
    name: "Integrity",
    dec: "Be real",
  },

  {
    id: uuidv4(),
    brand: Accountability,
    name: "Accountability",
    dec: "If it is to be, it's up to me.",
  },

  {
    id: uuidv4(),
    brand: Passion,
    name: "Passion",
    dec: "Committed in heart and mind",
  },
  {
    id: uuidv4(),
    brand: Diversity,
    name: "Diversity",
    dec: "As inclusive as our brands Quality: What we do, we do well ",
  },
];

export default BrandLogodata;
